var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"480px","width":"480px"}},[(_vm.currentPlayerObj.link_addr != '')?_c('Aliplayer',{ref:"player",staticStyle:{"min-heigth":"300px","height":"100%","padding":"0"},attrs:{"vid":_vm.currentPlayerObj.link_addr,"needLogin":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }